import React from 'react';
import { Image } from 'semantic-ui-react';

import goldTrophy from '../img/icon-trophy-gold.png';
import silverTrophy from '../img/icon-trophy-silver.png';

import '../css/Trophy.less';

import { register } from '../i18n';
import { SatCoreRegister } from '../SatCoreRegistry';

const t = register('Trophy');

const Trophy = (({ type, count } = {}) => {
  let trophyImg;
  let trophyImgLabel;
  let bandClass;
  let label;
  let rangeLabel;

  switch (type) {
    case 'gold':
      trophyImg = goldTrophy;
      trophyImgLabel = t('trophyGoldImgLabel');
      bandClass = 'gold-band';
      label = t('trophyGoldLabel', 'Gold');
      rangeLabel = t('trophyGoldRangeLabel', 'Scores 80% - 100%');
      break;
    case 'silver':
      trophyImg = silverTrophy;
      trophyImgLabel = t('trophySilverImgLabel');
      bandClass = 'silver-band';
      label = t('trophySilverLabel', 'Silver');
      rangeLabel = t('trophySilverRangeLabel', 'Scores 60% - 79%');
      break;
  }

  return (
    <div className='trophy' tabIndex={0}>
      <Image alt={trophyImgLabel} className='trophy-img' src={trophyImg} />
      <div aria-label={`${count} ${label}.`} className={`trophy-count ${bandClass}`}>
        {count}
        {' '}
        {label}
      </div>
      <div aria-hidden={true} className='trophy-range'>{rangeLabel}</div>
    </div>
  );
});

export default Trophy;

SatCoreRegister('Trophy', Trophy);
